import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Target, Play } from "lucide-react";

export function TestConfigView({ 
  testConfig, 
  setTestConfig, 
  subjects, 
  onStart, 
  onBack 
}) {
  return (
    <main className="max-w-2xl mx-auto px-4 py-6 space-y-6">
      <Card className="border-0 shadow-md">
        <CardHeader>
          <CardTitle>Select Subject</CardTitle>
          <CardDescription>Choose a subject for your practice test</CardDescription>
        </CardHeader>
        <CardContent className="grid grid-cols-1 gap-3">
          {subjects.map((subject) => (
            <Button
              key={subject}
              variant={testConfig.subject === subject ? "default" : "outline"}
              className={`justify-start h-14 ${testConfig.subject === subject ? "bg-emerald-600" : ""}`}
              onClick={() => setTestConfig({ ...testConfig, subject })}
              data-testid={`subject-${subject.toLowerCase()}`}
            >
              <Target className="w-5 h-5 mr-3" />
              {subject}
            </Button>
          ))}
        </CardContent>
      </Card>

      <Card className="border-0 shadow-md">
        <CardHeader>
          <CardTitle>Test Settings</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Number of Questions</label>
            <div className="flex gap-2 mt-2">
              {[5, 10, 15, 20].map((num) => (
                <Button
                  key={num}
                  variant={testConfig.numQuestions === num ? "default" : "outline"}
                  size="sm"
                  className={testConfig.numQuestions === num ? "bg-emerald-600" : ""}
                  onClick={() => setTestConfig({ ...testConfig, numQuestions: num })}
                >
                  {num}
                </Button>
              ))}
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Time Limit (minutes)</label>
            <div className="flex gap-2 mt-2">
              {[10, 15, 20, 30].map((mins) => (
                <Button
                  key={mins}
                  variant={testConfig.timeLimit === mins ? "default" : "outline"}
                  size="sm"
                  className={testConfig.timeLimit === mins ? "bg-emerald-600" : ""}
                  onClick={() => setTestConfig({ ...testConfig, timeLimit: mins })}
                >
                  {mins} min
                </Button>
              ))}
            </div>
          </div>
        </CardContent>
      </Card>

      <Button
        className="w-full h-14 bg-gradient-to-r from-emerald-600 to-teal-600 text-lg"
        onClick={onStart}
        disabled={!testConfig.subject}
        data-testid="start-test-btn"
      >
        <Play className="w-5 h-5 mr-2" />
        Start Test
      </Button>
    </main>
  );
}

export default TestConfigView;
